
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getPostList } from '@/api/post';
import InfiniteLoading from 'vue-infinite-loading';

@Component({
  components: {
    InfiniteLoading,
  },
})

export default class extends Vue {
  mounted() {
    this.getPostList();
  }

  private apiUrl = process.env.VUE_APP_COMMON_API;

  private shortListQuery: any = {
    boardUid: 'e418321d-654c-4611-bfe0-19dadb9917a0',
    page: 0,
    size: 10,
    searchType: '',
    searchValue: '',
  }

  private listQuery = {
    page: 0,
    size: 10,
    searchType: 'title',
    searchValue: '',
    sort: 'status',
  }

  private handleSearch() {
    this.postList = [];
    this.listQuery.page = 0;
    this.isNoMore = false;
    this.getPostList();
  }

  private isNoMore = false;

  private loading = true;

  private postList = [];

  private getPostList() {
    this.loading = true;
    getPostList(this.shortListQuery).then((res) => {
      this.postList = res.data.content;
      this.loading = false;
    });
  }

  private shortsNavigateToDetail(short: any) {
    const inputValue = short.dataList?.[0]?.inputValue;

    if (inputValue) {
      window.open(inputValue, '_blank');
    }
  }
}
